import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IExploreFilters } from 'src/features/common/explore/ducks/explore-nfts/explore-nfts.types';
import { useDebouncedCallback } from 'src/hooks/use-debounced-callback';
import { ArtAPI } from '@tacans/shared-marketplace-layer';
import { FilterRender } from './filter-render';
import { StyledNoFilterData } from './styles';
import { useFetchExploreArts } from '../../hooks/use-explore-arts';

interface IProps {
    selected: string[];
    onChange: (key: keyof IExploreFilters, payload: string[]) => void;
}

const DEFAULT_PAGER = { limit: 6, page: 0 };

export const TypesFilterContainer: React.VFC<IProps> = ({ selected, onChange }) => {
    const { t } = useTranslation(['components']);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const fetchExploreArts = useFetchExploreArts();
    // const [physicsArts, setPhysicsArts] = useState([]);
    // const [digitalArts, setDigitalArts] = useState([]);
    // useEffect(() => {
    //     const fetchData = async () => {
    //       const data = await ArtAPI.fetchByFilter({
    //         filter: {},
    //         pager: {limit: 10},
    //         sorting: {sort_by: "Date", ascending: false}
    //       });
    //       const physic = data?.data.list.filter(item => item.isPhysical);
    //       const digital = data?.data.list.filter(item => !item.isPhysical);
    //       // @ts-ignore
    //       setPhysicsArts(physic);
    //       // @ts-ignore
    //       setDigitalArts(digital);
    //     };
    //     fetchData().catch(console.error);
    //   }, []);


    const [pager, setPager] = useState(DEFAULT_PAGER);
    const types: string | any[] = [
        {
            id: true,
            name: 'Physical art',
        },
        {
            id: false,
            name: 'Digital art',
        }
    ];

    const filteredTypes = useMemo(() => {
        let result = types;
        if (searchValue.trim().length) {
            result = result.filter((c) => c.name.toLowerCase().indexOf(searchValue.trim().toLowerCase()) > -1);
        }
        return result;
    }, [types, searchValue]);

    const data = useMemo(
        () => filteredTypes.slice(0, pager.page * pager.limit + pager.limit),
        [filteredTypes, pager.limit, pager.page]
    );

    const loadMore = useCallback(async () => {
        setPager({
            page: pager.page + 1,
            limit: 10,
        });
    }, [pager.page]);

    const onSubmit = useCallback((e) => {
        setPager(DEFAULT_PAGER);
        setSearchValue(e.target.value);
    }, []);

    const handleSearch = useCallback((value: string) => {
        setPager(DEFAULT_PAGER);
        setSearchValue(value);
    }, []);

    const debouncedSearch = useDebouncedCallback(handleSearch, 500);

    useEffect(() => {
        if (types.length) {
            setShowSearch(types.length > 5);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredTypes]);



    return types.length ? (
        <FilterRender
            data={data}
            total={filteredTypes.length}
            loadMore={loadMore}
            onSubmit={onSubmit}
            onSearch={debouncedSearch}
            showSearch={showSearch}
            selected={selected}
            onFilterChange={onChange}
            filterName="isPhysical"
        />
    ) : (
        <StyledNoFilterData size="sm" tag="div">
            {t('exploreFilter.filter.categories.noFound')}
        </StyledNoFilterData>
    );

};
